import i18n from '@/plugins/i18n';
import { BaseNotification } from '@notify/models/notification/types/base';

export class RecordingExportComplete extends BaseNotification {
  constructor(data) {
    super(data);
    this.text = "";
    this.link = '';
   
  }
  getTheme() {
    return BaseNotification.THEME_ALERT;
  }

  areRecordsExist() {
    return this.params.data.success_count > 0
  }

  getText() {
    const props = this.getI18nProps();
    if (this.areRecordsExist()) {
      const link_tag = `<a href=${props.path}>${props.link}</a>`;
      this.text = `${props.text_success}`;
      this.link = props.link;
      return `${props.text_success} ${link_tag}`;
    }

    this.text = props.text_warning;
    this.link = '';
    return props.text_warning;
  }

  getI18nProps() {
    const path = `https://storage.zorra.com/${this.params.path}` || false;
    
    return {
      path,
      file_id: this.params.file_id,
      text_success: i18n.t('notify.notification.recording_export_complete.body'),
      text_warning: i18n.t('notify.notification.empty_records.body'),
      link: i18n.t('notify.notification.recording_export_complete.link'),
      text_body: this.text,
      text_link: this.link
    };
  }
}
